module.exports = __webpack_public_path__ + "6a25da4c18320a371db595f7e7cccef2.MP3";